import { Controller } from "@hotwired/stimulus"

// Bloquea el envío del form mientras alguna foto siga subiendo (photo-field:change / photo-list:change);
// solo toca los controles que él mismo deshabilitó. Doc: _docs/features/images/photo_field.md
const UPLOADING = "[data-photo-field-state-value='uploading'], [data-photo-list-state-value='uploading']"
const CONTROLS = "[type='submit'], [data-steps-target='nextButton']"

export default class extends Controller {
  connect() {
    this.sync()
  }

  sync() {
    const busy = this.element.querySelector(UPLOADING) !== null
    this.element.querySelectorAll(CONTROLS).forEach(control => {
      if (busy) {
        if (control.disabled) return
        control.disabled = true
        control.dataset.uploadLocked = "true"
      } else if (control.dataset.uploadLocked) {
        control.disabled = false
        delete control.dataset.uploadLocked
      }
    })
  }
}
